import React, { useEffect, useState } from "react";
import { ActivityIndicator, FlatList, Pressable, StyleSheet } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { serviceResponse } from "../../../services/common";
// import CommonService from "../../../services/common";
import { getPositions, Position } from "../../../services/Position";
import { RootState } from "../../../services/store/app";
import { setLocalPositions } from "../../../services/store/common";
import { colors } from "../../Shared";
import { View, Text } from "../../Themed";
import SettingsHeader from "../Header";
import PositionItem from "./Item";

interface Props {
    onCreate: () => void
}

// const commonService = new CommonService();

export default function PositionView({ onCreate }: Props) {
    const dispatch = useDispatch();
    const commonStore = useSelector((state: RootState) => state.commonReducer);
    const [init, setInit] = useState(false);
    const [positions, setPositions] = useState<Position[]>([]);
    // const [search, setSearch] = useState("");

    useEffect(() => {
        setPositions(commonStore.positions);
        setInit(true);
    }, [commonStore]);

    const unsubscribe = async () => {
        const req = await getPositions();

        if (req === serviceResponse.systemError) {
            return alert("Something went wrong, please try it again reloading");
        }

        if (req === serviceResponse.notContent) {
            return dispatch(setLocalPositions([]));
        }

        const data = req as Position[];
        dispatch(setLocalPositions(data));
    }

    useEffect(() => {
        unsubscribe();
    }, [])

    // const filter = ({ name }: Position) => {
    //     if(commonService.replaceSpecialChars(name).match(search))
    // }

    if (!init) {
        return <View style={styles.container}>
            <SettingsHeader title="Positions" onCreate={onCreate} />
            <ActivityIndicator size="large" />
        </View>
    }

    if (!positions.length) {
        return <View style={styles.container}>
            <SettingsHeader title="Positions" onCreate={onCreate} />

            <Text style={{ marginHorizontal: 'auto', marginTop: 15, fontSize: 14, fontWeight: '400' }}>
                Without positions
            </Text>
        </View>
    }

    return <View style={styles.container}>

        <SettingsHeader title="Positions" onCreate={onCreate} />

        <FlatList
            data={positions}
            style={{ flex: 1 }}
            // ListEmptyComponent={
            //     <View>
            //         <Text style={{ marginHorizontal: 'auto', marginTop: 15, fontSize: 14, fontWeight: '400' }}>Without results</Text>
            //     </View>
            // }
            renderItem={({ item, index }) => <PositionItem position={item} key={item.id} />}
        />
    </View>
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    headerContainer: {
        flexDirection: 'row',
        height: 50,
        backgroundColor: colors.bg.light,
        alignItems: 'center',
        padding: 5,
        margin: 5,
        borderRadius: 5,
    }
});